import { IProcessedStyleSet } from "@fluentui/react/lib/Styling"
import { classNamesFunction, styled } from "@fluentui/react/lib/Utilities"
import React from "react"

import { ComponentFactory } from "@encoway/react-configurator"

import { ProductPriceStyles } from "./ProductPrice.styles"
import { IProductPriceStyles, ProductPriceProps } from "./ProductPrice.types"

/**
 * The ProductPrice component renders the total price.
 *
 * Links:
 * - [Checkout the code](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ProductPrice/ProductPrice.tsx)
 * - [ProductPriceStyles](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ProductPrice/ProductPrice.styles.ts)
 * - [ProductPriceProps](https://gitlab.encoway-services.de/pd/dev/encoway-cpq/-/blob/master/cui/features/application-components/src/components/ProductPrice/ProductPrice.types.ts)
 *
 * @visibleName ProductPrice
 */
const IProductPrice = (props: ProductPriceProps) => {
    const { theme, styles, container, ...delegatedProps } = props
    const classNames = classNamesFunction()(
        styles,
        theme
    ) as IProcessedStyleSet<IProductPriceStyles>

    const price = container && container.totalPrice
    const currency = container && container.currency

    return (
        <div className={classNames.root}>
            {ComponentFactory.instanceOf("price", {
                price,
                currency,
                variant: "large",
                styles: {
                    root: {
                        color: theme?.palette?.themePrimary,
                        fontWeight: 600
                    }
                },
                ...delegatedProps
            })}
        </div>
    )
}

export const ProductPrice = styled(IProductPrice, ProductPriceStyles)
